module.exports = __webpack_public_path__ + "img/emoji_spritesheet_4.9759ad2b.png";